import { FormatStringByWordLength } from "../../../shared/scripts/array-functions";


export class WorkGroupEntity {

    FirstName: string;
    LastName: string;
    Email: string;
    ResearchHub: string;
    Role: string;
    Institution: string;
    CONNECT_Workgroup: string;


    SortName: string;
    DisplayName: string;
    DisplayEmail: string = "";

    initialize(): void {
        this.DisplayName = this.FirstName + " " + this.LastName;
        this.DisplayName = FormatStringByWordLength(this.DisplayName, 4);
        this.SortName = this.LastName + " " + this.FirstName;

        if (this.Email?.length > 0) {
            this.DisplayEmail = "<a href='mailto:" + this.Email + "'><span class='nowrap'>" + this.Email.toLowerCase() + "<i class='fa fa-envelope link-icon' aria-hidden='true'></i></span></a>";
            //this.DisplayName = "<a href='mailto:" + this.Email + "'><span class='nowrap'>" + this.DisplayName + "</span></a>";
        }
    }
}